import axios from 'axios';
import { clearSessionPlainPassword } from './sessionPlainPassword';

const baseURL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => {
    const body = res.data;
    if (body.code === 200) return body.data;
    const e = new Error(body.msg || '请求失败');
    e.code = body.code;
    e.data = body.data;
    return Promise.reject(e);
  },
  err => {
    if (err.response?.status === 401) {
      localStorage.clear();
      clearSessionPlainPassword();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.replace('/login');
      }
    }
    const msg = err.response?.data?.msg || err.message || '网络错误';
    const e = new Error(msg);
    e.httpStatus = err.response?.status;
    e.code = err.response?.data?.code;
    e.data = err.response?.data?.data;
    return Promise.reject(e);
  }
);

export default api;
